<template>
  <!-- 报名抽签结果弹窗 -->
  <el-dialog
    :model-value="show"
    title="参与报名抽签"
    width="400px"
    :append-to-body="true"
    :before-close="handleClose"
  >
    <div class="draw-box" v-if="status">
      <svg-icon icon="win_icon" class-name="draw-image" />
      <span class="result-title">恭喜抽中</span>
      <div class="result-hint">已成功报名，请按时参加</div>
    </div>
    <div class="draw-box" v-else>
      <svg-icon icon="lose_icon" class-name="draw-image" />
      <span class="result-title">抱歉，未抽中</span>
      <div class="result-hint">欢迎关注后续活动</div>
    </div>
  </el-dialog>
</template>

<script setup>
defineProps({
  show: {
    type: Boolean,
    default: false
  },
  status: Number // 1 中签 0 未中签
})

const emit = defineEmits(['update:show'])

const handleClose = () => {
  emit('update:show', false)
}
</script>

<style lang="scss" scoped>
.draw-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-block: 28px 58px;
  :deep(.draw-image) {
    font-size: 120px;
    color: $--color-primary;
  }
  .result-title {
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #0c0b22;
    font-weight: 500;
    margin-block: 30px 10px;
  }
  .result-hint {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #666666;
    font-weight: 400;
  }
}
</style>
